<footer class="page-footer py-3">
  <div class="text-center text-md-left container">
    <div class="row">
      <div class="col-auto">
        <ul>
          <li>©{{ today | date: 'yyyy' }} NuvemRx</li>
          <li><a href="https://www.nuvemrx.com/privacy-policy" target="_blank">Privacy Policy</a></li>
          @if (!isProduction) {
            <li>Version: {{ version }}</li>
          }
        </ul>
      </div>
    </div>
  </div>
</footer>
